import React from 'react'
import {
  FlowGrid,
  Ellipsis,
  colors,
  useContainerWidth,
  LayoutBand,
  Separator,
  Button,
  Card,
  Bleed,
  Paragraph,
  Image,
  H2,
  H3,
} from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import press from './images/press.jpg'
import contactUs from './images/contact-us.jpg'
import careers from './images/careers.jpg'

const spacingSmall = css`
  background-color: ${colors.gray02};
  padding-bottom: 24px;
`
const spacingLarge = css`
  background-color: ${colors.gray02};
  padding-bottom: 80px;
`
const headerPositioningSmall = css`
  padding: 32px;
`

// languages like korean may need to be added later. As this was done on sept. 3 2020 some likes where broken and not added.
const linkToCareer = {
  url: 'https://www.churchofjesuschrist.org/church/employment?lang=',
  en: 'eng',
  es: 'spa',
  da: 'deu',
  fr: 'fra',
  pt: 'por',
  zh: 'zho',
  ja: 'jpn',
}

export default function AboutPageGetConnected({ nonReligiousMode }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()

  return (
    <LayoutBand css={atWidth({ default: spacingSmall, sm: spacingLarge })}>
      <Separator />
      <div css={atWidth({ default: headerPositioningSmall })}>
        <H2 size={atWidth({ default: 'H5', lg: 'H4' })} centered>
          {t('about.get-connected.heading', 'Get Connected')}
        </H2>
      </div>
      <FlowGrid columnCount={!nonReligiousMode ? atWidth({ default: 1, lg: 3 }) : 1}>
        {!nonReligiousMode && (
          <Card to={`https://www.familysearch.org/${i18n.language}/newsroom/`} linkName="about:fs-media">
            <Bleed top sides>
              <Image src={press} aria-hidden height={240} alt={t('about.press.heading', 'Press')} />
            </Bleed>
            <Separator size="nano" />
            <H3 size="H5">
              <Ellipsis lineClamp={2}>{t('about.press.heading', 'Press')}</Ellipsis>
            </H3>
            <Separator size="nano" />
            <Paragraph growY size="sm">
              <Ellipsis lineClamp={2}>
                {t('about.press.body', 'Get access to tips and tricks for your family history work.')}
              </Ellipsis>
            </Paragraph>
            <Button>{t('about.check-it-out.link', 'Check it out')}</Button>
          </Card>
        )}
        {!nonReligiousMode && (
          <Card
            to={`${linkToCareer.url}${linkToCareer[i18n.language] || linkToCareer.en}`}
            linkName="about:view-careers"
          >
            <Bleed top sides>
              <Image src={careers} aria-hidden height={240} alt={t('about.careers.heading', 'Careers')} />
            </Bleed>
            <Separator size="nano" />
            <H3 size="H5">
              <Ellipsis lineClamp={2}>{t('about.careers.heading', 'Careers')}</Ellipsis>
            </H3>
            <Separator size="nano" />
            <Paragraph growY size="sm">
              <Ellipsis lineClamp={2}>{t('about.careers.body', 'View available jobs here at FamilySearch.')}</Ellipsis>
            </Paragraph>
            <Button>{t('about.view-careers.link', 'View careers')}</Button>
          </Card>
        )}
        <Card to="/help" linkName="about:contact-us" external>
          <Bleed top sides>
            <Image src={contactUs} aria-hidden height={240} alt={t('about.contact-us.heading', 'Contact Us')} />
          </Bleed>
          <Separator size="nano" />
          <H3 size="H5">
            <Ellipsis lineClamp={2}>{t('about.contact-us.heading', 'Contact Us')}</Ellipsis>
          </H3>
          <Separator size="nano" />
          <Paragraph growY size="sm">
            <Ellipsis lineClamp={2}>
              {t('about.contact-us.body', 'Get in contact with someone who can answer your questions.')}
            </Ellipsis>
          </Paragraph>
          <Button>{t('about.contact-us.link', 'Contact us')}</Button>
        </Card>
      </FlowGrid>
    </LayoutBand>
  )
}
